import { select, selectAll, on, getAttribute, getScrollTop, scrollTop } from 'modules/dom'
import { map } from 'modules/utils'
import { version } from './../../src/js/lib/detect-ie.js'

const scrollToTarget = (value) => {
  const target = select(value)
  const offset = target.getBoundingClientRect().top + getScrollTop()
  if (offset) {
    scrollTop(offset, undefined)
  }
}

export default function (el) {
  const links = selectAll('a', el)
  const selects = select('select', el)
  map((link) => {
    const href = getAttribute('href', link)
    const hash = href[0] === '#'
    if (hash) {
      on('click', () => {
        scrollToTarget(href)
      }, link)
    }
  }, links)
  map((select) => {
    if (select) {
      on('change', () => {
        const value = select.value
        if (value && value.indexOf('#') === 0) {
          scrollToTarget(value)
        }
      }, select)
    }
  }, selects)
  version()
}
